var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgFigma = function SvgFigma(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.33333C5 3.49238 6.49239 2 8.33333 2H11.6667V8.66667H8.33333C6.49238 8.66667 5 7.17428 5 5.33333V5.33333Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5.33333C18.3334 3.49238 16.841 2 15 2H11.6667V8.66667H15C16.841 8.66667 18.3334 7.17428 18.3334 5.33333V5.33333Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 11.9998C18.3334 10.1589 16.841 8.6665 15 8.6665V8.6665C13.1591 8.6665 11.6667 10.1589 11.6667 11.9998V11.9998C11.6667 13.8408 13.1591 15.3332 15 15.3332V15.3332C16.841 15.3332 18.3334 13.8408 18.3334 11.9998V11.9998Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9998C5 10.1589 6.49239 8.6665 8.33333 8.6665H11.6667V15.3332H8.33333C6.49238 15.3332 5 13.8408 5 11.9998V11.9998Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.6668C5 16.8259 6.49239 15.3335 8.33333 15.3335H11.6667V18.6668C11.6667 20.5078 10.1743 22.0002 8.33333 22.0002V22.0002C6.49238 22.0002 5 20.5078 5 18.6668V18.6668Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgFigma;